/*
 *   Useful constants that are reused throughout the application
 */
export const phone = {
  ddd: 71,
  number: 35003100,
  asStringNumber: '3500-3100',
  asStringFull: '(71) 3500-3100',
  e164: '+557135003100',
  whatsAppNumber: '557135003100',
};

/* UTM Manager constants */
export const VISITOR_LOG_ID_KEY = 'visitor-logs-id';
export const UTM_PAYLOAD_KEY = 'visitor-logs-utm-payload';
export const ORDER_NUMBER_KEY = 'visitor-logs-order-number';
export const USER_TOKEN_KEY = 'visitor-logs-user-token';
export const VISITOR_LOG_EXPIRES_AT_KEY = 'visitor-logs-expires-at';
export const VISITOR_LOG_EXPIRATION_DAYS = 30;
export const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
];
export const VISITOR_LOG_KEYS = [
  VISITOR_LOG_ID_KEY,
  UTM_PAYLOAD_KEY,
  ORDER_NUMBER_KEY,
  USER_TOKEN_KEY,
  VISITOR_LOG_EXPIRES_AT_KEY,
];
